<template>
  <el-form
    ref="ruleForm"
    :model="item"
    label-position="left"
    label-width="160px"
  >
    <el-divider>
      <span class="blue">Video</span>
    </el-divider>
    <el-form-item label="Type">
      <el-radio-group v-model="item.type">
        <el-radio class="video-type" label>Default</el-radio>
        <el-radio class="video-type" label="vast_url">VAST Url</el-radio>
        <el-radio
          class="video-type"
          label="youtube_video_id"
          v-if="this.isOutstream === false"
          >Youtube Player</el-radio
        >
        <el-radio
          v-if="this.useFacebookLivestream"
          class="video-type"
          label="facebook_video_url"
          >Facebook livestream
        </el-radio>
      </el-radio-group>
    </el-form-item>

    <el-form-item
      label="Video Url"
      prop="facebook_video_url"
      :rules="urlRule('facebook_video_url')"
      v-if="item.type === 'facebook_video_url'"
    >
      <el-input v-model="item.facebook_video_url"></el-input>
    </el-form-item>
    <el-form-item
      label="Video Landing Page"
      prop="facebook_video_landing_page"
      v-if="item.type === 'facebook_video_url'"
      key="facebook_video_landing_page"
    >
      <el-input v-model="item.facebook_video_landing_page"> </el-input>
    </el-form-item>
    <el-form-item
      label="Vast Url"
      prop="vast_url"
      :rules="urlRule('vast_url')"
      v-if="item.type === 'vast_url'"
    >
      <el-input v-model="item.vast_url"></el-input>
    </el-form-item>
    <el-form-item
      label="Video id"
      prop="youtube_video_id"
      v-if="item.type === 'youtube_video_id'"
      :rules="stringRule('youtube_video_id')"
    >
      <el-input v-model="item.youtube_video_id"></el-input>
    </el-form-item>
    <div v-if="!item.type">
      <el-form-item
        label="Video Url"
        prop="video_url"
        :rules="urlRule('video_url')"
      >
        <file-input accept="video/mp4" v-model="item.video_url"></file-input>
      </el-form-item>
      <el-form-item label="Skip Offset" prop="skip_offset" v-if="!replay">
        <el-input
          v-model.number="item.skip_offset"
          :min="0"
          :max="30"
          type="number"
        >
          <template slot="append">
            <label>seconds</label>
          </template>
        </el-input>
      </el-form-item>
    </div>

    <slot></slot>

    <div v-show="!item.type">
      <el-divider>
        <span class="blue">
          Video Trackings
        </span>
      </el-divider>
      <el-form-item
        label="click"
        prop="video_trackings.click"
        :rules="urlRule('video_trackings.click', false)"
      >
        <el-input v-model="item.video_trackings.click"></el-input>
      </el-form-item>
      <el-form-item
        label="start"
        prop="video_trackings.start"
        :rules="urlRule('video_trackings.start', false)"
      >
        <el-input v-model="item.video_trackings.start"></el-input>
      </el-form-item>
      <form-item-group
        title="impression"
        :min="0"
        :max="5"
        v-model="item.video_trackings.impression"
      >
        <template v-slot="{ index }">
          <el-form-item
            label="impression"
            :prop="`video_trackings.impression.${index}`"
            :rules="urlRule(`video_trackings.impression`)"
          >
            <el-input
              v-model="item.video_trackings.impression[index]"
            ></el-input>
          </el-form-item>
        </template>
      </form-item-group>
      <form-item-group
        title="impression5s"
        :min="0"
        :max="5"
        v-model="item.video_trackings.impression5s"
      >
        <template v-slot="{ index }">
          <el-form-item
            label="impression 5s"
            :prop="`video_trackings.impression5s.${index}`"
            :rules="urlRule(`video_trackings.impression5s`)"
          >
            <el-input
              v-model="item.video_trackings.impression5s[index]"
            ></el-input>
          </el-form-item>
        </template>
      </form-item-group>
      <form-item-group
        title="firstQuartile"
        :min="0"
        :max="5"
        v-model="item.video_trackings.firstQuartile"
      >
        <template v-slot="{ index }">
          <el-form-item
            label="firstQuartile"
            :prop="`video_trackings.firstQuartile.${index}`"
            :rules="urlRule(`video_trackings.firstQuartile`)"
          >
            <el-input
              v-model="item.video_trackings.firstQuartile[index]"
            ></el-input>
          </el-form-item>
        </template>
      </form-item-group>
      <form-item-group
        title="midpoint"
        :min="0"
        :max="5"
        v-model="item.video_trackings.midpoint"
      >
        <template v-slot="{ index }">
          <el-form-item
            label="midpoint"
            :prop="`video_trackings.midpoint.${index}`"
            :rules="urlRule(`video_trackings.midpoint`)"
          >
            <el-input v-model="item.video_trackings.midpoint[index]"></el-input>
          </el-form-item>
        </template>
      </form-item-group>
      <form-item-group
        title="thirdQuartile"
        :min="0"
        :max="5"
        v-model="item.video_trackings.thirdQuartile"
      >
        <template v-slot="{ index }">
          <el-form-item
            label="thirdQuartile"
            :prop="`video_trackings.thirdQuartile.${index}`"
            :rules="urlRule(`video_trackings.thirdQuartile`)"
          >
            <el-input
              v-model="item.video_trackings.thirdQuartile[index]"
            ></el-input>
          </el-form-item>
        </template>
      </form-item-group>
      <form-item-group
        title="complete"
        :min="0"
        :max="5"
        v-model="item.video_trackings.complete"
      >
        <template v-slot="{ index }">
          <el-form-item
            label="complete"
            :prop="`video_trackings.complete.${index}`"
            :rules="urlRule(`video_trackings.complete`)"
          >
            <el-input v-model="item.video_trackings.complete[index]"></el-input>
          </el-form-item>
        </template>
      </form-item-group>
      <el-form-item
        label="skip"
        prop="video_trackings.skip"
        :rules="urlRule('video_trackings.skip', false)"
        v-if="!replay"
      >
        <el-input v-model="item.video_trackings.skip"></el-input>
      </el-form-item>
    </div>
  </el-form>
</template>

<script>
import { mapState } from "vuex";
import { VASTParser } from "vast-client";
import FileInput from "@/components/base/forms/fileInput";
import MixFormRule from "@/components/mixins/formRule";
import FormItemGroup from "./formItemGroup.vue";

const vastParser = new VASTParser();
const domParser = new DOMParser();
const vastTag = {
  type: "",
  vast_url: "",
  vast_xml: "",
  youtube_video_id: "",
  facebook_video_url: "",
  facebook_video_landing_page: "",
  video_url: "",
  skip_offset: "",
  video_trackings: {
    click: "",
    start: "",
    impression: [],
    impression5s: [],
    firstQuartile: [],
    midpoint: [],
    thirdQuartile: [],
    complete: [],
    skip: "",
  },
};

export default {
  props: {
    replay: Boolean, // if replay is true, value doesn't need skip_offset
    isOutstream: Boolean,
    useFacebookLivestream: Boolean,
  },
  data() {
    return {
      item: _.cloneDeep(vastTag),
    };
  },
  components: {
    FileInput,
    FormItemGroup,
  },
  computed: {
    ...mapState({
      assets: (state) => state.asset.assets,
    }),
  },
  mixins: [MixFormRule],
  methods: {
    vastUrlRule(prop, required = true) {
      const name = _.lowerCase(prop);
      const rules = this.urlRule(prop, required);
      return rules.concat([
        {
          validator: async (rule, value, callback) => {
            if (value) {
              try {
                const parseVAST = await vastParser.getAndParseVAST(value);
                callback();
              } catch (error) {
                console.log(error);
                callback(new Error(`VAST url error`));
              }
            }
          },
          trigger: ["blur", "change"],
        },
      ]);
    },
    // vastXmlRule(prop, required = true) {
    //   const name = _.lowerCase(prop);
    //   return [
    //     {
    //       required,
    //       message: `Please input ${name}`,
    //       trigger: ["blur", "change"],
    //     },
    //     {
    //       validator: async (rule, value, callback) => {
    //         try {
    //           const vast_xml = domParser.parseFromString(value, "text/xml");
    //           const parseVAST = await vastParser.parseVAST(vast_xml);
    //           const { creatives } = parseVAST.ads[0];
    //           const {
    //             trackingEvents,
    //             videoClickTrackingURLTemplates,
    //           } = creatives.find((creative) => creative.type === "linear");
    //           const eventCheck = {
    //             complete: ["{{VIDEO_COMPLETE}}"],
    //             firstQuartile: ["{{VIDEO_FIRST_QUARTILE}}"],
    //             midpoint: ["{{VIDEO_MIDPOINT}}"],
    //             "progress-5": ["{{VIDEO_IMPRESSION_5S}}"],
    //             skip: ["{{VIDEO_SKIP}}"],
    //             start: ["{{VIDEO_START}}"],
    //             thirdQuartile: ["{{VIDEO_THIRD_QUARTILE}}"],
    //             viewable_impression: [
    //               "{{VIDEO_IMPRESSION}}",
    //               "{{IMPRESSION_TRACKING}}",
    //               "{{THIRD_PARTY_IMPRESSION_MACRO}}",
    //             ],
    //           };
    //           let trackingRemoveSec = _.cloneDeep(trackingEvents);
    //           ["firstQuartile", "midpoint", "thirdQuartile", "complete"].map(
    //             (event) => {
    //               trackingRemoveSec[event].map((URI, index) => {
    //                 if (URI.includes(eventCheck[event][0])) {
    //                   trackingRemoveSec[event][index] = URI.split("?")[0];
    //                 }
    //               });
    //             }
    //           );
    //           for (let event in eventCheck) {
    //             eventCheck[event].forEach((URI) => {
    //               if (!trackingRemoveSec[event]) {
    //                 callback(
    //                   new Error(`Tracking event ${event} is required on ${URI}`)
    //                 );
    //               } else if (!trackingRemoveSec[event].includes(URI)) {
    //                 callback(
    //                   new Error(
    //                     `${URI} is required and need to add ${event} tracking event`
    //                   )
    //                 );
    //               }
    //             });
    //           }

    //           callback();
    //         } catch (error) {
    //           console.log(error);
    //           callback(new Error(`VAST Xml format error`));
    //         }
    //       },
    //       trigger: ["blur", "change"],
    //     },
    //   ];
    // },
    async get_video_info(url) {
      const res = await fetch(url);
      return {
        mime_type: res.headers.get("Content-type"),
        size: res.headers.get("Content-Length"),
      };
    },
    get_duration(url) {
      return new Promise((resolve) => {
        const video = document.createElement("video");
        video.src = url;
        video.onloadedmetadata = () => {
          resolve(video.duration);
        };
      });
    },
    async generateVastTrackingWithVideo(video_url) {
      const video_duration = await this.get_duration(video_url);
      let firstQ_sec = Math.floor(video_duration / 4);
      let midpoint_sec = Math.floor(video_duration / 2);
      let thirdQ_sec = Math.floor(video_duration * 0.75);
      let complete_sec = Math.floor(video_duration);
      return `<Tracking event='viewable_impression'><![CDATA[{{VIDEO_IMPRESSION}}]]></Tracking>
        <Tracking event='viewable_impression'><![CDATA[{{IMPRESSION_TRACKING}}]]></Tracking>
        <Tracking event='viewable_impression'><![CDATA[{{THIRD_PARTY_IMPRESSION_MACRO}}]]></Tracking>
        <Tracking event='start'><![CDATA[{{VIDEO_START}}]]></Tracking>
        <Tracking event='progress' offset='00:00:05'><![CDATA[{{VIDEO_IMPRESSION_5S}}]]></Tracking>
        <Tracking event='firstQuartile'><![CDATA[{{VIDEO_FIRST_QUARTILE}}?sec=${firstQ_sec}]]></Tracking>
        <Tracking event='midpoint'><![CDATA[{{VIDEO_MIDPOINT}}?sec=${midpoint_sec}]]></Tracking>
        <Tracking event='thirdQuartile'><![CDATA[{{VIDEO_THIRD_QUARTILE}}?sec=${thirdQ_sec}]]></Tracking>
        <Tracking event='complete'><![CDATA[{{VIDEO_COMPLETE}}?sec=${complete_sec}]]></Tracking>
        <Tracking event='skip'><![CDATA[{{VIDEO_SKIP}}]]></Tracking>`;
    },
    async setData(row) {
      this.item = _.cloneDeep(vastTag);
      if (row.vast_url) {
        this.item.type = "vast_url";
      } else if (row.is_custom && row.youtube_video_id) {
        this.item.type = "youtube_video_id";
      } else if (row.is_custom && row.facebook_video_url) {
        this.item.type = "facebook_video_url";
      } else {
        this.item.type = "";
      }

      if (this.item.type === "vast_url") {
        this.item.vast_url = decodeURI(row.vast_url);
      } else if (this.item.type === "youtube_video_id") {
        this.item.youtube_video_id = row.youtube_video_id;
      } else if (this.item.type === "facebook_video_url") {
        this.item.facebook_video_url = row.facebook_video_url;
        this.item.facebook_video_landing_page = row.facebook_video_landing_page;
      } else {
        const vast_xml = domParser.parseFromString(row.vast_xml, "text/xml");
        const res = await vastParser.parseVAST(vast_xml);
        const { creatives } = res.ads[0];
        const {
          skipDelay,
          mediaFiles,
          videoClickTrackingURLTemplates,
          trackingEvents,
        } = creatives.find((creative) => creative.type === "linear");
        this.item.skip_offset = skipDelay;
        this.item.video_trackings.click = videoClickTrackingURLTemplates[3]
          ? decodeURI(videoClickTrackingURLTemplates[3])
          : "";
        this.item.video_trackings.start = trackingEvents.start[1]
          ? decodeURI(trackingEvents.start[1])
          : "";
        if (trackingEvents.viewable_impression[3]) {
          this.item.video_trackings.impression = trackingEvents.viewable_impression
            .filter((impression, index) => index >= 3)
            .map((impression) => decodeURI(impression));
        }
        if (trackingEvents["progress-5"][1]) {
          this.item.video_trackings.impression5s = trackingEvents["progress-5"]
            .filter((impression5s, index) => index >= 1)
            .map((impression5s) => decodeURI(impression5s));
        }
        if (trackingEvents.firstQuartile[1]) {
          this.item.video_trackings.firstQuartile = trackingEvents.firstQuartile
            .filter((firstQuartile, index) => index >= 1)
            .map((firstQuartile) => decodeURI(firstQuartile));
        }
        if (trackingEvents.midpoint[1]) {
          this.item.video_trackings.midpoint = trackingEvents.midpoint
            .filter((midpoint, index) => index >= 1)
            .map((midpoint) => decodeURI(midpoint));
        }
        if (trackingEvents.thirdQuartile[1]) {
          this.item.video_trackings.thirdQuartile = trackingEvents.thirdQuartile
            .filter((midpoint, index) => index >= 1)
            .map((thirdQuartile) => decodeURI(thirdQuartile));
        }
        if (trackingEvents.complete[1]) {
          this.item.video_trackings.complete = trackingEvents.complete
            .filter((complete, index) => index >= 1)
            .map((complete) => decodeURI(complete));
        }

        this.item.video_trackings.skip = trackingEvents.skip[1]
          ? decodeURI(trackingEvents.skip[1])
          : "";
        this.item.video_url = decodeURI(mediaFiles[0].fileURL);
      }
    },
    async getData(setObj, width, height) {
      const {
        vast_url,
        video_url,
        youtube_video_id,
        skip_offset,
        video_trackings,
        facebook_video_url,
        facebook_video_landing_page,
      } = this.item;
      let TRACKING_EVENTS = "";
      let VIDEO_CLICKS = "";

      if (setObj.landing_page) {
        VIDEO_CLICKS += `<ClickThrough><![CDATA[${
          setObj.landing_page
        }]]></ClickThrough>`;
      }

      const SKIPOFFSET = !this.replay
        ? `skipoffset='${moment.utc(skip_offset * 1000).format("HH:mm:ss")}'`
        : "";

      setObj.is_custom = [
        "vast_url",
        "vast_xml",
        "youtube_video_id",
        "facebook_video_url",
      ].includes(this.item.type)
        ? true
        : false;
      setObj.vast_url =
        this.item.type === "vast_url" ? encodeURI(vast_url) : "";
      if (this.item.type === "vast_url") {
        const res = await vastParser.getAndParseVAST(this.item.vast_url);
        const { creatives } = res.ads[0];
        const { mediaFiles } = creatives.find(
          (creative) => creative.type === "linear"
        );
        const videoUrlParseFromVast = decodeURI(mediaFiles[0].fileURL);
        TRACKING_EVENTS = await this.generateVastTrackingWithVideo(
          videoUrlParseFromVast
        );
        setObj.vast_xml = `<VAST version='4.0'>
          <Ad id='{{ADSESSION_ID}}'>
            <Wrapper>
              <AdSystem>ucX</AdSystem>
              <VASTAdTagURI><![CDATA[${encodeURI(vast_url)}]]></VASTAdTagURI>
              <Creatives>
                <Creative>
                  <Linear>
                    <TrackingEvents>
                      ${TRACKING_EVENTS}
                    </TrackingEvents>
                    <VideoClicks>
                      ${VIDEO_CLICKS}
                    </VideoClicks>
                  </Linear>
                </Creative>
              </Creatives>
            </Wrapper>
          </Ad>
        </VAST>`;
        this.clearOtherTypeData(setObj, this.item.type);
      } else if (this.item.type === "youtube_video_id") {
        setObj.youtube_video_id = youtube_video_id;
        setObj.vast_xml = "";
        this.clearOtherTypeData(setObj, this.item.type);
      } else if (this.item.type === "facebook_video_url") {
        setObj.facebook_video_url = facebook_video_url;
        setObj.facebook_video_landing_page = facebook_video_landing_page;
        this.clearOtherTypeData(setObj, this.item.type);
      } else {
        TRACKING_EVENTS = await this.generateVastTrackingWithVideo(video_url);
        const resp = await Promise.all([
          this.get_video_info(video_url),
          this.get_duration(video_url),
        ]);
        const { mime_type, size } = resp[0];
        const duration = resp[1];
        const bitrate = Math.round(size / duration / 1024);
        let MEDIA_FILE = "";
        _.forEach(video_trackings, (v, k) => {
          if (!v) return;
          if (k === "impression") {
            v.forEach((ele) => {
              TRACKING_EVENTS += `<Tracking event='viewable_impression'><![CDATA[${encodeURI(
                ele
              )}]]></Tracking>`;
            });
          } else if (k === "impression5s") {
            v.forEach((ele) => {
              TRACKING_EVENTS += `<Tracking event='progress' offset='00:00:05'><![CDATA[${encodeURI(
                ele
              )}]]></Tracking>`;
            });
          } else if (k === "click") {
            VIDEO_CLICKS += `<ClickTracking><![CDATA[${encodeURI(
              v
            )}]]></ClickTracking>`;
          } else {
            if (Array.isArray(v)) {
              v.forEach((ele) => {
                TRACKING_EVENTS += `<Tracking event='${k}'><![CDATA[${encodeURI(
                  ele
                )}]]></Tracking>`;
              });
            } else {
              TRACKING_EVENTS += `<Tracking event='${k}'><![CDATA[${encodeURI(
                v
              )}]]></Tracking>`;
            }
          }
        });
        if (video_url.includes(config.cdn_url)) {
          const asset = _.find(
            this.assets,
            (asset) => asset.url === video_url || asset.ffmpeg_url === video_url
          );
          if (asset && asset.ffmpeg_url) {
            const url = asset.ffmpeg_url;
            const ffmpeg_bitrate = Math.round(size / duration / 1024);
            MEDIA_FILE = `<MediaFile width='${width}' height='${height}' type='${mime_type}' bitrate='${ffmpeg_bitrate}' delivery='progressive'><![CDATA[${encodeURI(
              url
            )}]]></MediaFile>`;
          } else if (asset && asset.url) {
            MEDIA_FILE = `<MediaFile width='${width}' height='${height}' type='${mime_type}' bitrate='${bitrate}' delivery='progressive'><![CDATA[${encodeURI(
              asset.url
            )}]]></MediaFile>`;
          }
        }

        setObj.vast_xml = `<VAST version='4.0'>
          <Ad id='{{ADSESSION_ID}}'>
            <InLine>
              <AdSystem><![CDATA[ucX]]></AdSystem>
              <Creatives>
                <Creative>
                  <Linear ${SKIPOFFSET}>
                    <Duration>${moment
                      .utc(duration * 1000)
                      .format("HH:mm:ss")}</Duration>
                    <TrackingEvents>
                      ${TRACKING_EVENTS}
                    </TrackingEvents>
                    <VideoClicks>
                      ${VIDEO_CLICKS}
                    </VideoClicks>
                    <MediaFiles>
                      ${MEDIA_FILE}
                    </MediaFiles>
                  </Linear>
                </Creative>
              </Creatives>
            </InLine>
          </Ad>
        </VAST>`;
        this.clearOtherTypeData(setObj, this.item.type);
      }
      return setObj;
    },

    clearOtherTypeData(setObj, type) {
      const youtube = ["youtube_video_id"];
      const facebook = ["facebook_video_url", "facebook_video_landing_page"];
      const vast = ["vast_url", "vast_xml"];
      let clearKey;
      if (type === "youtube_video_id") {
        clearKey = [...facebook, ...vast];
      } else if (type === "facebook_video_url") {
        clearKey = [...youtube, ...vast];
      } else {
        clearKey = [...youtube, ...facebook];
      }
      clearKey.forEach((key) => {
        setObj[key] = "";
      });
    },
  },
};
</script>

<style lang="sass" scoped>
.video
  &-type
    height: 20px
</style>
